// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconUnfavorite = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12">
            <path
                fill="currentColor"
                d="M6.95379997,0.417152855 L8.48731542,3.52027843 L11.918566,4.01926229 C12.5342696,4.10823152 12.7808311,4.86512158 12.3345816,5.29871533 L9.85255051,7.69168422 L10.4396596,11.1018405 C10.5453157,11.718481 9.89520622,12.1776223 9.35005045,11.8916845 L6.28114343,10.3030908 L3.21317482,11.9132466 C2.667081,12.1991844 2.01786196,11.7398092 2.12333071,11.1234033 L2.71044016,7.71324703 L0.227705958,5.29918453 C-0.218309639,4.86559078 0.0281124136,4.10879371 0.64372194,4.01973149 L4.0749718,3.52074692 L5.60848725,0.417622063 C5.88505018,-0.142604855 6.67958129,-0.135643986 6.95380032,0.417152855 L6.95379997,0.417152855 Z"
            />
        </svg>
    );
};

export default React.memo(IconUnfavorite);
